import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Trophy, Calendar, Users } from "@phosphor-icons/react";

/**
 * Shows the user's upcoming bracket matches across all retas.
 * Visible only when user has at least 1 upcoming match.
 */
export default function UpcomingBracketMatches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/retas/bracket/my-upcoming");
      setMatches(r.data?.matches || []);
    } catch (e) {
      // silent: feature is optional
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading || matches.length === 0) return null;

  return (
    <div className="bg-gradient-to-br from-amber-500/10 via-orange-500/5 to-transparent border border-amber-500/30 rounded-lg p-4" data-testid="upcoming-bracket-matches">
      <div className="flex items-center gap-2 mb-3">
        <Trophy size={18} weight="fill" className="text-amber-400" />
        <h3 className="font-['Barlow_Condensed'] text-lg uppercase tracking-wider text-white font-bold">Tus Próximos Partidos</h3>
        <Badge className="bg-amber-500 text-black font-bold ml-auto text-[10px]">{matches.length}</Badge>
      </div>
      <div className="space-y-2 max-h-80 overflow-y-auto">
        {matches.map((m, idx) => (
          <div key={m.match_id} className="bg-black/40 border border-amber-500/20 rounded p-2.5 hover:border-amber-500/40 transition-colors" data-testid={`upcoming-match-${idx}`}>
            <div className="flex items-center justify-between gap-2 mb-1.5">
              <Badge className="bg-amber-500/20 text-amber-300 border-amber-500/30 text-[9px] font-bold uppercase">{m.round_name}</Badge>
              {(m.date || m.time) && (
                <span className="text-[10px] text-gray-400 flex items-center gap-1">
                  <Calendar size={10} /> {m.date || ""} {m.time || ""}
                </span>
              )}
            </div>
            {m.teammate && (
              <div className="text-[10px] text-gray-400 flex items-center gap-1 mb-1">
                <Users size={10} /> Compañero: <span className="text-[#CCFF00]">{m.teammate}</span>
              </div>
            )}
            <div className="flex items-center gap-2 text-xs">
              <span className="text-[10px] tracking-widest uppercase text-gray-500 font-bold">vs</span>
              <span className="text-white font-bold">{m.opponent}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
